import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { Web3State, Web3Store } from './web3.store';
import { distinctUntilChanged } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class Web3Query extends Query<Web3State> {
  constructor(protected override store: Web3Store) {
    super(store);
  }
  readonly isTransaction$ = this.select((state) => state.isTransaction).pipe(
    distinctUntilChanged(),
  );
  readonly isFetchingData$ = this.select((state) => state.isFetchingData).pipe(
    distinctUntilChanged(),
  );
  readonly isLoginModalVisible$ = this.select((state) => state.loginModalVisibility);
  readonly adapterEvent$ = this.select((state) => state.adapterEvents);
  readonly ethTransaction$ = this.select((state) => state.txReceipt);
  readonly successKey = this.select((state) => state.successMessageKey);
  readonly errorKey = this.select((state) => state.errorMessageKey).pipe(distinctUntilChanged());
  readonly error = this.select((state) => state.error);
  readonly hasEthProvider$ = this.select((state) => state.hasEthProvider);
  readonly account$ = this.select((state) => state.address).pipe(distinctUntilChanged());
  readonly accounts$ = this.select((state) => state.address);
  readonly chainId$ = this.select((state) => state.chainId).pipe(distinctUntilChanged());
}
